import { render, staticRenderFns } from "./CrudRecetas.vue?vue&type=template&id=17be2fad&lang=es"
import script from "./CrudRecetas.vue?vue&type=script&lang=js"
export * from "./CrudRecetas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports